import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { RoleManagementComponent } from '../role-management/role-management.component';
import { PrivilegeManagementComponent } from '../privilege-management/privilege-management.component';
import { AuthService } from 'src/app/services/auth/auth.service';

enum View {
  ROLES = 'ROLES',
  PRIVILEGES = 'PRIVILEGES',
}

@Component({
  selector: 'app-role-management-landing',
  templateUrl: './role-management-landing.component.html',
  styleUrls: ['./role-management-landing.component.scss'],
  standalone: false
})
export class RoleManagementLandingComponent implements OnInit {
  uri: string = '';

  activeTab: View = View.ROLES;
  View = View;

  searchForm: FormGroup;



  @ViewChild(RoleManagementComponent) roleManagementComponent!: RoleManagementComponent
  @ViewChild(PrivilegeManagementComponent) privilegeManagementComponent!: PrivilegeManagementComponent

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }


  tabs =  [
    {
      slug: View.ROLES,
      label: 'Role Management',
      tabAction: () => this.roleManagementComponent?.createRole(),
      searchAction: () => this.roleManagementComponent?.search()
    },
    {
      slug: View.PRIVILEGES,
      label: 'Priviledges',
      tabAction: this.privilegeManagementComponent?.createPrivilege(),
      searchAction: this.privilegeManagementComponent?.search()
    }
  ]

  ngOnInit(): void {
    const snapshot = this.route.snapshot;
    this.activeTab = snapshot.queryParams['type'] ? snapshot.queryParams['type'] as View : View.ROLES;
  }

  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions)
  }

  setIsActive(type: View) {
    this.router
      .navigate(['admin/role-management'], { queryParams: { type: type } })
      .then(() => {
        location.reload();
      });

    this.activeTab = type;
  }




  handleTabAction() {

    switch(this.activeTab) {
      case View.ROLES:
        this.roleManagementComponent?.createRole();
        break;
      case View.PRIVILEGES:
        this.privilegeManagementComponent.createPrivilege();
    }
  }

  handleSearchAction() {

    switch(this.activeTab) {
      case View.ROLES:
        this.roleManagementComponent?.toggleShowSearch();
        break;
      case View.PRIVILEGES:
        this.privilegeManagementComponent.toggleShowSearch();
    }
  }
}
